import { BaseMenu } from "./base-menu";

export class ContentMenu extends BaseMenu {
    site: boolean = false;
    genus: boolean = false;
    folder: boolean = false;
    content: boolean = false;
}
